import script from "./hero-slider.vue?vue&type=script&setup=true&lang=js"
export * from "./hero-slider.vue?vue&type=script&setup=true&lang=js"

import "./hero-slider.vue?vue&type=style&index=0&id=eb013184&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb013184"]])

export default __exports__